import { render } from "./NewsletterSection.vue?vue&type=template&id=be9564b0&scoped=true"
import script from "./NewsletterSection.vue?vue&type=script&lang=js"
export * from "./NewsletterSection.vue?vue&type=script&lang=js"

import "./NewsletterSection.vue?vue&type=style&index=0&id=be9564b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9564b0"]])

export default __exports__